import { map, get, curry } from 'lodash-es';

const groupFacetsByTargetGroup = facets => {
  return facets.reduce((groups, facet) => {
    const group = facet.config.group;
    return { ...groups, [group]: [...(groups[group] || []), facet] };
  }, {});
};

const formatGroups = (groupedFacets, groupsConfig) => {
  return map(groupedFacets, (groupFacets, groupKey) => {
    const groupConfig = get(groupsConfig, [groupKey], {});

    return {
      groupKey,
      facets: groupFacets,
      ...groupConfig,
    };
  });
};

export const groupFacets = curry((groupsConfig, facets) => {
  const groupedDictionary = groupFacetsByTargetGroup(facets);
  return formatGroups(groupedDictionary, groupsConfig);
});
